import { FC } from 'react';

import { useEditStore } from 'page/NotificationPage/hooks';
import { DeleteModalView } from 'page/NotificationPage/components/DeleteModalView';

type Props = {
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickDelete: () => void;
};

export const DeleteModal: FC<Props> = ({
  handleClose,
  handleClickGoInput,
  handleClickDelete,
}) => {
  const { isOpenDeleteModal, title } = useEditStore();

  return (
    <>
      {/* 削除モーダル */}
      <DeleteModalView
        isOpen={isOpenDeleteModal}
        title={title}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickDelete={handleClickDelete}
      />
    </>
  );
};
